/**
 * @file getSubmittedTrueValues.ts
 * Exports a method for returning the IDs of answers with true values.
 */
import type { AppState } from '../types';
import { forEachObjIndexed, prop } from 'ramda';

/**
 * Helper method that returns a list of IDs for answers with true values.
 *
 * Submitted answers are organized in a Map object indexed by question id. Each
 * question may have multiple answers organized in the submitted data values.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 *
 * @returns {Array}
 *   An array of all of the submitted answer id's where the value is true.
 */
export default (appState: AppState): string[] => {
  const answers: string[] = [];

  // If an answer has a truthy value, then add the answer id to the array.
  const addTrueAnswers = (value: unknown, id: string) => {
    if (value) answers.push(id);
  };

  type QuestionType = {
    value: boolean;
    id: string;
  };

  // Iterate through each question, then iterate through each answer.
  forEachObjIndexed((question: QuestionType) =>
    forEachObjIndexed(addTrueAnswers, question),
  )(prop('submitted')(appState));

  return answers;
};
